import { ArrowBackIosNewOutlined } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface IProps extends ButtonProps {
  to?: string;
}

const ButtonBack = ({ sx = {}, color = 'inherit', to, ...others }: IProps) => {
  const navigate = useNavigate();

  return (
    <Button
      sx={{ cursor: 'pointer', ...sx }}
      variant="text"
      color={color}
      onClick={() => {
        if (to) navigate(to);
        else navigate(-1);
      }}
      {...others}
    >
      <ArrowBackIosNewOutlined sx={{ mr: 1, fontSize: 14 }} />
      BACK
    </Button>
  );
};

export default ButtonBack;
